// extracted by mini-css-extract-plugin
export default {"root":"LmOhPNHrS09KaWwDT6rA","tag":"oWpYf7RN_8nuCnhl9Dpt"};